<template>
  <section class="home-hero">
    <div class="hero-decor" aria-hidden="true">
      <div class="hero-line hero-line-left"></div>
      <div class="hero-line hero-line-right"></div>
    </div>
    <div class="hero-content">
      <p class="hero-kicker">美菜网 为8亿农民谋幸福</p>
      <h1>美菜致力于用互联网与科技升级农业与餐饮供应链。</h1>
      <p class="hero-description">
        中国领先的餐饮供应链服务商，独有的“两端一链一平台”模式，帮农户稳销路、增收入，帮餐厅省成本、提效率。已覆盖全国数百座城市，服务超百万餐饮商户。
      </p>
      <div class="hero-actions">
        <router-link class="primary-action" to="/download_app">
          客户端下载
          <span class="action-code">
            <img src="@/assets/images/new-img/home/mc-app.png" alt="美菜商城客户端下载二维码" />
            <small>扫码下载美菜商城客户端</small>
          </span>
        </router-link>
        <router-link class="secondary-action" to="/download_app">
          关注微信商城
          <span class="action-code">
            <img src="@/assets/images/new-img/home/mc-wx.png" alt="美菜微信商城二维码" />
            <small>微信扫码关注商城</small>
          </span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeHero"
};
</script>

<style lang="scss" scoped>
.home-hero {
  box-sizing: border-box;
  position: relative;
  min-height: 540px;
  padding: 90px 28px;
  background: #f5f6f7;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.hero-decor {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.hero-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}

.hero-kicker {
  margin: 0 0 34px;
  color: #161c26;
  font-family: "Noto Sans SC", "Source Han Sans SC", "PingFang SC", system-ui, sans-serif;
  font-size: clamp(48px, 5.4vw, 78px);
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: -0.055em;
}

h1 {
  margin: 0 auto 24px;
  color: #39414c;
  font-family: "Noto Sans SC", "Source Han Sans SC", "PingFang SC", system-ui, sans-serif;
  font-size: clamp(24px, 2.5vw, 36px);
  font-weight: 500;
  letter-spacing: -0.025em;
  line-height: 1.55;
}

.hero-description {
  max-width: 900px;
  margin: 0 auto;
  color: #707986;
  font-size: 15px;
  line-height: 2;
}

.hero-actions {
  display: flex;
  position: relative;
  z-index: 2;
  margin-top: 38px;
  gap: 14px;
  justify-content: center;
}

.hero-actions a {
  display: inline-block;
  box-sizing: border-box;
  padding: 12px 22px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;
  position: relative;
  text-decoration: none;
}

.primary-action {
  border: 1px solid #78ae40;
  background: #78ae40;
  color: #fff;
}

.secondary-action {
  border: 1px solid #91b56e;
  background: #fff;
  color: #587e38;
}

.action-code {
  position: absolute;
  top: calc(100% + 16px);
  left: 50%;
  display: flex;
  width: 150px;
  padding: 10px;
  transform: translateX(-50%) scale(0.96);
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 14px 38px rgba(19, 34, 25, 0.18);
  opacity: 0;
  pointer-events: none;
  z-index: 3;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.action-code img {
  width: 130px;
  height: 130px;
  object-fit: contain;
}

.action-code small {
  margin-top: 7px;
  color: #667268;
  font-size: 10px;
  line-height: 1.4;
  white-space: nowrap;
}

.hero-actions a:hover .action-code,
.hero-actions a:focus .action-code {
  transform: translateX(-50%) scale(1);
  opacity: 1;
}

.hero-line {
  position: absolute;
  top: -290px;
  width: 1000px;
  height: 720px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 50%;
}

.hero-line-left {
  left: auto;
}

.hero-line-right {
  right: auto;
}

@media (max-width: 1080px) {
  .home-hero { min-height: 500px; padding-right: 28px; padding-left: 28px; }
  .hero-kicker { font-size: clamp(48px, 7.2vw, 68px); }
}

@media (max-width: 720px) {
  .home-hero { min-height: 530px; padding: 74px 22px; }
  .hero-kicker { margin-bottom: 26px; font-size: 40px; letter-spacing: -.065em; }
  h1 { margin-bottom: 16px; font-size: 22px; line-height: 1.55; }
  .hero-description { font-size: 13px; line-height: 1.8; }
  .hero-actions { margin-top: 28px; gap: 10px; }
  .hero-actions a { min-width: 0; padding: 11px 13px; font-size: 12px; }
  .action-code { top: calc(100% + 12px); }
  .hero-line { width: 760px; height: 600px; }
}
</style>
